import React from "react";
import { ChatShell } from "../../chat/ChatShell";
import { PageTemplate } from "../../templates/PageTemplate";
import { ConversationIntakePageProps } from "../ConversationIntake/ConversationIntakePage.contract";

import { deriveConversationState } from "../../../conversation/intakeConversation";

export const ChatIntakePage: React.FC<ConversationIntakePageProps> = ({
  accountDraft,
  userDraft,
  opportunityDraft,
  onBack,
  onCompleteConversation,
}) => {
  return (
    <PageTemplate
      id="chat-intake"
      className="min-h-[calc(100vh-72px)]"
      header={{
        kicker: "Conversation Mode 🪄",
        title: "Talk it through. We build the play live.",
        description:
          "Drop the messy clues here—links, emails, or notes. We'll structure the play, review the profile, and lock the path without a single form.",
        actions: (
          <button
            type="button"
            onClick={onBack}
            className="bg-brand-surface border border-black/10 text-brand-ink px-6 py-3 rounded-full font-medium hover:bg-black/5 transition-all active:scale-95"
          >
            Back
          </button>
        ),
      }}
    >
      <div className="max-w-4xl mx-auto">
        <ChatShell
          isIntakeMode
          onIntakeComplete={(answers) => {
            const derived = deriveConversationState(
              accountDraft,
              userDraft,
              opportunityDraft,
              answers,
            );

            onCompleteConversation({
              signal: {
                signalType: (answers.signalType as any) || "note",
                signalText: String(answers.signalText || ""),
                signalUrl: String(answers.signalUrl || ""),
              },
              accountDraft: derived.accountDraft,
              userDraft: derived.userDraft,
              opportunityDraft: derived.opportunityDraft,
            });
          }}
        />
      </div>
    </PageTemplate>
  );
};
